interface CdtStudioContext {
  isPog: boolean;
  merchflowId?: number;
  hasCategoryIdentity: boolean;
  hasCategoryConfiguration: boolean;
  canEditCdt: boolean;
  merchantName?: string | null;
}

export type CdtStudioUnavailableReason =
  | "notPlanogram"
  | "missingMerchflow"
  | "unsupportedMerchant"
  | "missingPermission"
  | "categoryUnavailable"
  | "configurationRequired";

export type CdtStudioAvailability =
  | { isAvailable: true }
  | { isAvailable: false; reason: CdtStudioUnavailableReason };

export const getCdtStudioAvailability = ({
  isPog,
  merchflowId,
  hasCategoryIdentity,
  hasCategoryConfiguration,
  canEditCdt,
  merchantName,
}: CdtStudioContext): CdtStudioAvailability => {
  if (!isPog) return { isAvailable: false, reason: "notPlanogram" };
  if (merchflowId === undefined) return { isAvailable: false, reason: "missingMerchflow" };
  if (!(merchantName?.toLocaleLowerCase().includes("walmart") ?? false)) {
    return { isAvailable: false, reason: "unsupportedMerchant" };
  }
  if (!canEditCdt) return { isAvailable: false, reason: "missingPermission" };
  if (!hasCategoryIdentity) return { isAvailable: false, reason: "categoryUnavailable" };
  if (!hasCategoryConfiguration) {
    return { isAvailable: false, reason: "configurationRequired" };
  }
  return { isAvailable: true };
};

export const isCdtStudioEnabled = (context: CdtStudioContext): boolean =>
  getCdtStudioAvailability(context).isAvailable;
